export const YES = "common_yes";
export const NO = "common_no";
export const CANCEL = "common_cancel";
export const VALIDATE = "common_validate";
